import "./App.css";
import { useEffect, useState } from "react";
import Navbar from "./components/maincomponent/navbar";
import SideBar from "./components/maincomponent/sidebar";
import Login from "./components/maincomponent/login/login";
import PrivateRoutes from "./components/maincomponent/login/privateroutes";
import ActionAlerts from "./components/maincomponent/popupalert/popupalert";
import CircularIndeterminate from "./components/maincomponent/loader/progressloader";
import DashBoard from "./components/pages/dashboard";
import TestPage from "./components/form/formvalidation";
import Patient from "./components/pages/patient";
import Adminpage from "./components/pages/adminpage";
import Doctor from "./components/pages/doctorpage";
import DoctorForm from "./components/form/doctorform";
import DoctorView from "./components/pages/doctorview";
import Speciality from "./components/pages/speciality";
import Symptoms from "./components/pages/symptoms";
import PatientView from "./components/pages/patientview";
import ErrorPage from "./components/error/errorpage";
import Pharmacy from "./components/pages/pharmacy";
import Banner from "./components/pages/banner";
import Investigations from "./components/pages/investigation";
import Packages from "./components/pages/packages";
import ProductOrder from "./components/pages/ProductOrderpage";
import DiagnosticsBanner from "./components/pages/diagnosticsbanner";
import DiagnosticsBannerForm from "./components/form/diagnosticsbannerform";
import DiagnosticsIssue from "./components/pages/diagnosticsissue";
import PharacyIssue from "./components/pages/pharmacyissue";
import PharmacyIssueList from "./components/pages/PharmacyIssueList";
import PharmacyBill from "./components/pages/pharmacybill";
import DiagnosticsBill from "./components/pages/diagnosticsbill";
import BannerVideo from "./components/pages/bannervideo";
import BillPayments from "./components/pages/billpayments";
import Notification from "./components/form/sendnotification";
import DiagnosticsOrder from "./components/pages/DiagnosticsOrderpage";
import CashBack from "./components/pages/cashback";
import AppoinmentDetails from "./components/pages/appoinmentdetails";
import PharmacyDetails from "./components/pages/pharmacydetails";
import DiagnosticsDetails from "./components/pages/diagnosticsdetails";
import DiagnosticsRecords from "./components/pages/diagsticsrecords";
import CraniumBillingList from "./components/pages/craniumbillinglist";
import AppoinmentsReschedule from "./components/pages/AppoinmentsReschedule";
import PatientBannerVideo from "./components/pages/patienttestimonials";
import MedicineType from "./components/pages/medicinetype";
import PharmacyNew from "./components/pages/pharmacynewpage/pharmacynew";
import PharmacyRequest from "./components/pages/pharmacyrequest";
import PharmacyBannerVideo from "./components/pages/pharmacybanner";
import PharmacyRequestForm from "./components/form/pharmacynew/pharmacyrequestform";
import ProductOrderNew from "./components/pages/pharmacynewpage/pharmacyordernew";
import AdminAccess from "./components/pages/Admin_access";
import PatientAppoinmentsReschedule from "./components/pages/PatientAppoinmentReschedule";
import PharmacyAppoinment from "./components/pages/PharmacyAppoinmentCancel";
import DiagnosticsAppoinment from "./components/pages/DiagnosticsAppoinment";
import IpCancelRequest from "./components/pages/ipcancelrequest";
import OpCancelRequest from "./components/pages/opcancelrequest";
import PharmacyCancelRequest from "./components/pages/pharmacycancelrequest";
import FinancialDashboard from "./components/pages/financialdashboard";
import CashBack1 from "./components/pages/cashback copy";
import PatientForm from "./components/pages/patientedit";
import PharmacyProductReturn from "./components/form/pharmacynew/pharmacy_product_return";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.js";
import "bootstrap-icons/font/bootstrap-icons.css";
// import "rsuite/dist/rsuite.css";
import { admincreate } from "./text/apidata";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Requestviaprescription from "./components/pages/Requestviapresciption";
import Requestviapharmacyform from "./components/form/pharmacynew/Requestviapharmacyform";
import LaunchApp from "./components/pages/LaunchApp";
import VideoPlay from "./components/pages/VideoPlay";
import DashboardBanner from "./components/pages/dashboardbanner";
import RevisedCashback from "./components/pages/RevisedCashback";

function App() {
  const Error = useNavigate();
  const popup = useSelector(state => state.counter.popupalert);
  const loaderdata = useSelector(state => state.counter.loader);
  var logintest = localStorage.getItem("login");
  const [alertpopuptext, setalertpopuptext] = useState("");
  const [loader, setLoader] = useState(loaderdata);
  const [alertpopup, setalertpopup] = useState(popup);

  const [errorstatus, seterrorstatus] = useState("");
  // useEffect(()=>{
  //   handleChnage("1")
  //     },[])
  //     const handleChnage=(e)=>{
  //       var browserZoomLevel = Math.round((window.outerWidth / window.innerWidth) * 100);
  //       console.log(browserZoomLevel,(window.innerHeight),window.innerWidth)
  //       var doc=document.getElementsByClassName("App")
  //       let zoom=(window.innerWidth/1820)*100
  //       console.log(Math.round(zoom))
  //       doc[0].style.zoom=`${Math.round(zoom)}%`
  //     }

  //     window.addEventListener("resize",handleChnage)
  useEffect(() => {
    axios({
      method: "get",
      url: admincreate,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token") + "",
      },
    })
      .then(res => {
        // console.log(res, "###########################################");
      })
      .catch(error => {
        // console.log(error, "###########################################");
        // if ('config" ) ASAP
        seterrorstatus(error?.response?.status);
        if (error.response.status) {
          if (logintest == "false") {
            Error("/Error");
          }
        }
      });
  }, [alertpopup]);
  const loaderchange = arg => {
    setLoader(arg);
  };

  const popupalert = arg => {
    setalertpopup(arg);
  };
  const popuptext = arg => {
    setalertpopuptext(arg);
  };

  return (
    <div className="App">
      {loader == "true" ? (
        <div
          className="loader"
          style={{
            position: "absolute",
            height: "100%",
            width: "100%",
            zIndex: "999",
          }}
        >
          <CircularIndeterminate />
        </div>
      ) : (
        ""
      )}

      {alertpopup == "true" ? (
        <ActionAlerts alertpopuptext={alertpopuptext} popupalert={popupalert} />
      ) : (
        ""
      )}

      <>
        {logintest == "false" ? (
          <>
            <Navbar popupalert={popupalert} popuptext={popuptext} />
            <SideBar />
            <Routes>
              <Route
                element={
                  <DashBoard
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/"
              />
              {/* <Route element={<TestPage/>} path="/TestPage"></Route> */}
              <Route
                element={
                  <Adminpage
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/AdminUser"
              ></Route>
              <Route
                element={
                  <AdminAccess
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/AdminAccess"
              ></Route>
              <Route
                element={
                  <Doctor
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Doctor"
              ></Route>
              <Route
                element={
                  <DoctorForm
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DoctorCreate"
              ></Route>
              <Route
                element={
                  <DoctorView
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DoctorView"
              ></Route>
              <Route
                element={
                  <Patient
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Patient"
              ></Route>
              <Route
                element={
                  <Symptoms
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Symptoms"
              ></Route>
              <Route
                path="/Banner"
                element={
                  <Banner
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
              ></Route>
              <Route
                element={
                  <Speciality
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Speciality"
              ></Route>
              <Route
                element={
                  <Pharmacy
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Pharmacy"
              ></Route>
              <Route
                element={
                  <PatientView
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PatientView"
              ></Route>
              <Route
                element={
                  <ProductOrder
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Productsorder"
              ></Route>
              <Route
                element={
                  <Investigations
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Investigations"
              ></Route>
              <Route
                element={
                  <Packages
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Packages"
              ></Route>
              <Route
                element={
                  <DiagnosticsBanner
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DiagnosticsBanner"
              ></Route>
              <Route
                element={
                  <DiagnosticsBannerForm
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DiagnosticsBanner"
              ></Route>
              <Route
                element={
                  <DiagnosticsIssue
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DiagnosticsIssueReport"
              ></Route>
              <Route
                element={
                  <PharacyIssue
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PharmacyIssue"
              ></Route>
              <Route
                element={
                  <PharmacyIssueList
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/IssueList"
              ></Route>
              <Route
                element={
                  <BannerVideo
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/BannerVideo"
              ></Route>
              <Route
                element={
                  <PharmacyBill
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Pharmacybill"
              ></Route>{" "}
              <Route
                element={
                  <RevisedCashback
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/returnedCashback"
              ></Route>{" "}
              <Route
                element={
                  <DiagnosticsBill
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Diagnosticsbill"
              ></Route>
              <Route
                element={
                  <BillPayments
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/BillPayments"
              ></Route>
              <Route
                element={
                  <Notification
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/SendNotification"
              ></Route>
              <Route
                element={
                  <DiagnosticsOrder
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Diagnosticsorder"
              ></Route>
              <Route
                element={
                  <CashBack
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/CashBackPoints"
              ></Route>
              <Route
                element={
                  <AppoinmentDetails
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/AppoinmentDetails"
              ></Route>{" "}
              <Route
                element={
                  <PharmacyDetails
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PharmacyDetails"
              ></Route>{" "}
              <Route
                element={
                  <DiagnosticsDetails
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DiagnosticsDetails"
              ></Route>
              <Route
                element={
                  <DiagnosticsRecords
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DiagnosticsRecords"
              ></Route>
              <Route
                element={
                  <CraniumBillingList
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/kraniumBillingList"
              ></Route>
              <Route
                element={
                  <AppoinmentsReschedule
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Appoinments"
              ></Route>
              <Route
                element={
                  <PatientBannerVideo
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Patienttestimonials"
              ></Route>
              <Route
                element={
                  <DashboardBanner
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DashboardBanner"
              ></Route>
              <Route
                element={
                  <PharmacyNew
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PharmacyNew"
              ></Route>
              <Route
                element={
                  <PharmacyBannerVideo
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PharmacyBannerVideo"
              ></Route>
              <Route
                element={
                  <MedicineType
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/MedicineType"
              ></Route>
              <Route
                element={
                  <PharmacyRequest
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PharmacyRequest"
              ></Route>
              <Route
                element={
                  <PharmacyRequestForm
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PharmacyRequestForm"
              ></Route>
              <Route
                element={
                  <Requestviapharmacyform
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/requestviaprescriptionform"
              ></Route>
              <Route
                element={
                  <ProductOrderNew
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/Productsordernew"
              ></Route>
              <Route
                element={
                  <Requestviaprescription
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/prescriptionrequest"
              ></Route>
              <Route
                element={
                  <PatientAppoinmentsReschedule
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PatientAppoinments"
              ></Route>
              <Route
                element={
                  <PharmacyAppoinment
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PharmacyAppoinments"
              ></Route>
              <Route
                element={
                  <DiagnosticsAppoinment
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DiagnosticsAppoinments"
              ></Route>
              <Route
                element={
                  <IpCancelRequest
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/BillPaymentsCancelRequest"
              ></Route>{" "}
              <Route
                element={
                  <OpCancelRequest
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/DiagnosticsbillCancelRequest"
              ></Route>{" "}
              <Route
                element={
                  <PharmacyCancelRequest
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PharmacybillCancelRequest"
              ></Route>
              <Route
                element={
                  <FinancialDashboard
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/FinancialDashBoard"
              ></Route>
              <Route
                element={
                  <PatientForm
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/PatientForm"
              ></Route>
              {/* <Route
                element={
                  <LaunchApp
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/applaunch"
                ></Route>
                <Route
                element={
                  <VideoPlay
                    loaderchange={loaderchange}
                    popupalert={popupalert}
                    popuptext={popuptext}
                  />
                }
                path="/videoplay"
                ></Route> */}
              <>
                <Route
                  element={<ErrorPage errorstatus={errorstatus} />}
                  path="/Error"
                ></Route>
              </>
            </Routes>
          </>
        ) : (
          <Routes>
            <Route element={<PrivateRoutes />} path="/" exact />
            <Route
              path="/login"
              element={
                <Login
                  loaderchange={loaderchange}
                  popupalert={popupalert}
                  popuptext={popuptext}
                />
              }
            />
          </Routes>
        )}
      </>
    </div>
  );
}

export default App;
